import { instance } from "libs/api";

import { ApiRoutesDeliveryFees } from "../../constants";
import {
  DeliveryZoneExistingRequestParams,
  DeliveryZoneExistingResponse
} from "./deliveryZoneExisting.types";

export const requestGetDriverById = async (
  params: DeliveryZoneExistingRequestParams
): Promise<DeliveryZoneExistingResponse> => {
  return await instance.get(ApiRoutesDeliveryFees.DeliveryZoneExisting, {
    params
  });
};
